"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarehouseErrorCode = exports.WarehouseAuthErrorCode = exports.WarehouseGetShipmentsErrorCode = exports.WarehouseCancelShipmentErrorCode = exports.WarehouseGetProductDetailErrorCode = exports.WarehouseSendToWarehouseErrorCode = exports.WarehouseCreateAsnErrorCode = exports.WarehouseGetAsnStatusErrorCode = exports.WarehouseCreateProductErrorCode = exports.WarehouseCommonErrorCode = void 0;
var WarehouseCommonErrorCode;
(function (WarehouseCommonErrorCode) {
    WarehouseCommonErrorCode["BAD_GATEWAY_ERR"] = "BAD_GATEWAY_ERR";
    WarehouseCommonErrorCode["BAD_REQUEST_ERR"] = "BAD_REQUEST_ERR";
    WarehouseCommonErrorCode["BAD_WAREHOUSE_ERR"] = "BAD_WAREHOUSE_ERR";
    WarehouseCommonErrorCode["UNKNOWN_ERR"] = "UNKNOWN_ERR";
    WarehouseCommonErrorCode["VALIDATION_ERR"] = "VALIDATION_ERR";
    WarehouseCommonErrorCode["NETWORK_ERR"] = "NETWORK_ERR";
    WarehouseCommonErrorCode["UNAUTHORIZED"] = "UNAUTHORIZED";
    WarehouseCommonErrorCode["PUSH_EVENT_ROUTING_ERROR"] = "PUSH_EVENT_ROUTING_ERROR";
    WarehouseCommonErrorCode["OUTBOUNDS_BLOCKED_ERR"] = "OUTBOUNDS_BLOCKED_ERR";
})(WarehouseCommonErrorCode || (exports.WarehouseCommonErrorCode = WarehouseCommonErrorCode = {}));
var WarehouseCreateProductErrorCode;
(function (WarehouseCreateProductErrorCode) {
    WarehouseCreateProductErrorCode["DUPLICATE_PRODUCT"] = "DUPLICATE_PRODUCT_SKU";
    WarehouseCreateProductErrorCode["DUPLICATE_BARCODE"] = "DUPLICATE_BARCODE";
})(WarehouseCreateProductErrorCode || (exports.WarehouseCreateProductErrorCode = WarehouseCreateProductErrorCode = {}));
var WarehouseGetAsnStatusErrorCode;
(function (WarehouseGetAsnStatusErrorCode) {
    WarehouseGetAsnStatusErrorCode["ASN_NOT_FOUND_ERR"] = "ASN_NOT_FOUND_ERR";
})(WarehouseGetAsnStatusErrorCode || (exports.WarehouseGetAsnStatusErrorCode = WarehouseGetAsnStatusErrorCode = {}));
var WarehouseCreateAsnErrorCode;
(function (WarehouseCreateAsnErrorCode) {
    WarehouseCreateAsnErrorCode["ASN_ITEM_NOT_FOUND_ERR"] = "ASN_ITEM_NOT_FOUND_ERR";
    WarehouseCreateAsnErrorCode["DUPLICATE_ASN"] = "DUPLICATE_ASN_ID";
})(WarehouseCreateAsnErrorCode || (exports.WarehouseCreateAsnErrorCode = WarehouseCreateAsnErrorCode = {}));
var WarehouseSendToWarehouseErrorCode;
(function (WarehouseSendToWarehouseErrorCode) {
    WarehouseSendToWarehouseErrorCode["BAD_SHIPPING_ADDRESS_ERR"] = "BAD_SHIPPING_ADDRESS_ERR";
    WarehouseSendToWarehouseErrorCode["BAD_SHIPPING_METHOD_ERR"] = "BAD_SHIPPING_METHOD_ERR";
    WarehouseSendToWarehouseErrorCode["BAD_CARRIER_ERR"] = "BAD_CARRIER_ERR";
    WarehouseSendToWarehouseErrorCode["BAD_PACKAGE_TYPE_ERR"] = "BAD_PACKAGE_TYPE_ERR";
    WarehouseSendToWarehouseErrorCode["DUPLICATE_SHIPMENT"] = "DUPLICATE_SHIPMENT";
})(WarehouseSendToWarehouseErrorCode || (exports.WarehouseSendToWarehouseErrorCode = WarehouseSendToWarehouseErrorCode = {}));
var WarehouseGetProductDetailErrorCode;
(function (WarehouseGetProductDetailErrorCode) {
    WarehouseGetProductDetailErrorCode["SKU_NOT_FOUND_ERR"] = "SKU_NOT_FOUND_ERR";
    WarehouseGetProductDetailErrorCode["PRODUCT_UNAVAILABLE"] = "PRODUCT_UNAVAILABLE";
})(WarehouseGetProductDetailErrorCode || (exports.WarehouseGetProductDetailErrorCode = WarehouseGetProductDetailErrorCode = {}));
var WarehouseCancelShipmentErrorCode;
(function (WarehouseCancelShipmentErrorCode) {
    WarehouseCancelShipmentErrorCode["ALREADY_CANCELLED"] = "ALREADY_CANCELLED";
})(WarehouseCancelShipmentErrorCode || (exports.WarehouseCancelShipmentErrorCode = WarehouseCancelShipmentErrorCode = {}));
var WarehouseGetShipmentsErrorCode;
(function (WarehouseGetShipmentsErrorCode) {
    WarehouseGetShipmentsErrorCode["SHIPMENT_NOT_FOUND_ERR"] = "SHIPMENT_NOT_FOUND_ERR";
    WarehouseGetShipmentsErrorCode["BAD_TRACKING_CODE"] = "BAD_TRACKING_CODE";
    WarehouseGetShipmentsErrorCode["NO_TRACKING_CODE"] = "NO_TRACKING_CODE";
    WarehouseGetShipmentsErrorCode["NO_INVENTORY_ERR"] = "NO_INVENTORY_ERR";
    WarehouseGetShipmentsErrorCode["ON_HOLD_ERR"] = "ON_HOLD_ERR";
})(WarehouseGetShipmentsErrorCode || (exports.WarehouseGetShipmentsErrorCode = WarehouseGetShipmentsErrorCode = {}));
var WarehouseAuthErrorCode;
(function (WarehouseAuthErrorCode) {
    WarehouseAuthErrorCode["UNKNOWN_USER"] = "UKNOWN_USER";
    WarehouseAuthErrorCode["UNKNOWN_GROUP"] = "UNKNOWN_GROUP";
})(WarehouseAuthErrorCode || (exports.WarehouseAuthErrorCode = WarehouseAuthErrorCode = {}));
exports.WarehouseErrorCode = {
    ...WarehouseCommonErrorCode,
    ...WarehouseCreateProductErrorCode,
    ...WarehouseGetAsnStatusErrorCode,
    ...WarehouseCreateAsnErrorCode,
    ...WarehouseSendToWarehouseErrorCode,
    ...WarehouseGetProductDetailErrorCode,
    ...WarehouseCancelShipmentErrorCode,
    ...WarehouseGetShipmentsErrorCode,
    ...WarehouseAuthErrorCode,
};
//# sourceMappingURL=WarehouseErrorCode.js.map